import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'react-magma-dom';
import {
  setSelectedParameterFilter,
  getSelectedParameterByName,
  calculateRawDatasetSummary
} from 'store/dataset';

import ParameterFiltersModalComponent from './ModalContent';

const ParameterFiltersModalContainer = ({ parameterName, isOpen, onCloseModal }) => {
  const parameter = useSelector(state => getSelectedParameterByName(state, parameterName));
  const dispatch = useDispatch();

  const handleAddFilter = payload => {
    dispatch(setSelectedParameterFilter(parameter.name, payload));
    dispatch(calculateRawDatasetSummary());
    onCloseModal();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCloseModal}
      header={`Filter for '${parameterName}'`}
    >
      <ParameterFiltersModalComponent
        parameter={parameter}
        onAddFilter={handleAddFilter}
      />
    </Modal>
  );
};


ParameterFiltersModalContainer.propTypes = {
  // values
  parameterName: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default ParameterFiltersModalContainer;
